import { schema } from 'normalizr';

export const OPTIN_LIST = '/:clientToken/optins';

// ------------------------------------
// Schemas
// ------------------------------------

const OPTIN_SCHEMA = new schema.Entity('optins', {}, { idAttribute: '@id' });

export default {
  Optin: OPTIN_SCHEMA,
};
